import React from 'react';
import PropTypes from 'prop-types';
import FittingStationStore from '../../../stores/fitting_station_store';
import StationsActions from '../../../actions/fitting_station_actions';
import FinderHeaderComponent from './finder_header';
import FinderStationListHeaderComponent from './finder_station_list_header';
import FinderStationListComponent from './finder_station_list';
import FinderMapComponent from './finder_map';
import LoadingLocker from '../../loading_locker/loading_locker';
import FittingStationFinderConstants from '../../../constants/fitting_station_finder_constants';
import { getMap } from '../../../helper/gmap';
import { ProductsStore } from '../../../stores/products_store';
import { updateAction } from '../../../actions/products_actions';
import parseGoogleLatLng from '../../../helper/parse_google_lat_lng';
import MapStore from '../../../stores/map_store';
import PostcodeStore from '../../../stores/postcode_store';
import MapActions from '../../../actions/map_actions';
import LightboxActions from '../../../actions/lightbox_actions';
import { onChangePostcodeAction, postcodeExistsButNeedsToBeLoaded, postcodeValidAction } from '../../../actions/postcode_actions';
import { getValue } from '../../../../utilities/local_storage';

class FinderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.getInitialStates();
    }

    getInitialStates() {
        var fittingStationStoreState = FittingStationStore.getState();

        return {
            detailModeStation: fittingStationStoreState.detailModeStation,
            sorting: fittingStationStoreState.sorting,
            loading: fittingStationStoreState.loading,
            loadingPrices: fittingStationStoreState.loadingPrices,
            hoveredStation: '',
            quantity: null,
            listMapView: FittingStationFinderConstants.MAPLIST_VIEW,
            isMapLocationChanged: false,
            isListActive: true,
        };
    }
    componentDidMount() {
        FittingStationStore.addListener(() => {
            var fittingStationStoreState = FittingStationStore.getState();
            this.setState({
                detailModeStation: fittingStationStoreState.detailModeStation,
                sorting: fittingStationStoreState.sorting,
                loading: fittingStationStoreState.loading,
                loadingPrices: fittingStationStoreState.loadingPrices,
            });
        });

        $(window).on('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
    }

    render() {
        const props = this.props;
        const { stations } = props;
        const state = this.state;
        const listViewContainerStyle = {};

        const classNames = ['fsf__app'];
        if (state.detailModeStation) {
            classNames.push('fsf__app--show-active-station-only');
        }

        const headerLocation = state.detailModeStation ?
            stations.find((x) => x.id === state.detailModeStation).name :
            props.postcode;

        if (state.listMapView === FittingStationFinderConstants.MAP_VIEW && !state.detailModeStation) {
            listViewContainerStyle.display = 'none';
        }
        if (state.listMapView !== FittingStationFinderConstants.MAPLIST_VIEW) {
            listViewContainerStyle.width = '100%';
        }

        const detailModeStation = stations.find(x => x.id === state.detailModeStation);

        const finderContainerClassName = ['finder-container'];
        if (state.detailModeStation) {
            finderContainerClassName.push('is-in-detail-mode');
        }

        return (
            <section className={classNames.join(' ')}>
                <LoadingLocker active={state.loading} />
                <FinderHeaderComponent
                    isListActive={state.isListActive}
                    detailModeStation={detailModeStation}
                    location={headerLocation}
                    inDetailMode={state.detailModeStation}
                    showSelectStationButton={props.showSelectStationButton}
                    onMapViewClick={this.onMapViewClick.bind(this)}
                    onListViewClick={this.onListViewClick.bind(this)}
                    onShowStationListClick={FinderComponent.onListModeClick}
                />
                <div className={finderContainerClassName.join(' ')}>
                    <div className="finder-list" style={listViewContainerStyle}>
                        <FinderStationListHeaderComponent
                            postcode={props.postcode}
                            appliedPostcode={props.appliedPostcode}
                            postcodeInvalid={props.postcodeInvalid}
                            postcodeInvalidMessage={props.postcodeInvalidMessage}
                            sorting={state.sorting}
                            onSortingChange={FinderComponent.onSortingChange}
                            onQuantityChange={FinderComponent.onQuantityChange}
                            onPostcodeUpdate={props.onPostcodeUpdate}
                            onPostcodeSubmit={props.onPostcodeSubmit}
                            showChangePostcodeForm={props.showChangePostcodeForm}
                            onChangePostcodeClick={props.onChangePostcodeClick}
                            showQuantityInput={props.showQuantityInput}
                            availableQuantities={props.availableQuantities}
                            productsQty={props.productsQty}
                            selectPostcodeSuggestion={props.selectPostcodeSuggestion}
                            store={props.store}
                        />
                        {/*<div*/}
                        {/*key="xmas-msg"*/}
                        {/*className="fitting-stations__xmas-msg"*/}
                        {/*>*/}
                        {/*<Translation translationKey="fitting-station-xmas-message" />*/}
                        {/*</div>*/}
                        <FinderStationListComponent
                            ref="stationList"
                            loading={state.loading}
                            loadingPrices={state.loadingPrices}
                            showSelectStationButton={props.showSelectStationButton}
                            showDisplayName={props.showDisplayName}
                            showSuccessPage={props.showSuccessPage}
                            stations={props.stations}
                            activeStation={props.activeStation}
                            detailModeStation={state.detailModeStation}
                            hoveredStation={state.hoveredStation}
                            wheelAlignment={props.wheelAlignment}
                            productsPrice={props.productsPrice}
                            productsQty={props.productsQty}
                            productBrand={props.productBrand}
                            productModel={props.productModel}
                            productManufacturer={props.productManufacturer}
                            productDimensions={props.productDimensions}
                            onDetailModeClick={FinderComponent.onDetailModeClick.bind(this)}
                            onListModeClick={FinderComponent.onListModeClick}
                            onStationSelect={this.onStationSelect.bind(this)}
                            onStationHover={this.onStationHover.bind(this)}
                            onStationHoverEnd={this.onStationHoverEnd.bind(this)}
                            onWheels2Change={props.onWheels2Change}
                            onWheels4Change={props.onWheels4Change}
                            showAllCosts={props.showAllCosts}
                            onShowAllCostsClick={StationsActions.showAllCostsAction}
                            onHideAllCostsClick={StationsActions.hideAllCostsAction}
                            onShowMoreWheelAlignmentInfoClick={this.props.onShowMoreWheelAlignmentInfoClick}
                            staticUrl={props.staticUrl}
                            store={props.store}
                            buy4Pay3={props.buy4Pay3}
                        />
                    </div>
                    <FinderMapComponent
                        ref="mapComponent"
                        listMapView={state.listMapView}
                        stations={props.stations}
                        activeStation={props.activeStation}
                        detailModeStation={state.detailModeStation}
                        hoveredStation={state.hoveredStation}
                        isMapLocationChanged={state.isMapLocationChanged}
                        onDetailModeClick={FinderComponent.onDetailModeClick.bind(this)}
                        onListModeClick={FinderComponent.onListModeClick}
                        onStationSelect={FinderComponent.onStationSelect}
                        onStationHover={this.onStationHover.bind(this)}
                        onStationHoverEnd={this.onStationHoverEnd.bind(this)}
                        onMapLocationChanged={this.onMapLocationChanged.bind(this)}
                        wheelAlignment={props.wheelAlignment}
                    />
                </div>
            </section>
        );
    }

    static onSortingChange(sorting) {
        StationsActions.sortStationsAction(sorting);
    }

    static onQuantityChange(qty) {
        const id = ProductsStore.getState()[0].id;
        updateAction({ id, qty });
        StationsActions.startFetchingStationsAction();
        const latLng = parseGoogleLatLng(MapStore.getState().latLng);
        const { appliedPostcode } = PostcodeStore.getState();
        MapActions.updateLatLngAction(appliedPostcode).then(() => {
            const products = ProductsStore.getState();
            StationsActions.fetchStationsAction({
                postcode: appliedPostcode,
                latitude: latLng.lat,
                longitude: latLng.lng,
            }, products);

            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
            getMap().updateView();
        });
    }

    static onDetailModeClick(stationID) {
        onChangePostcodeAction(getValue('shippingPostcode'));
        PostcodeStore.getState().touched = false;
        postcodeValidAction();
        StationsActions.hideChangePostcodeForm();
        StationsActions.showDetailsAction(stationID);

        let detailModeStation = this.props.stations.find(x => x.id === stationID);

        getMap().panToLocation({
            lat: detailModeStation.latitude,
            lng: detailModeStation.longitude
        });
    }

    static onListModeClick() {
        StationsActions.showListAction();
    }

    onStationHover(stationID, { markerHovered, stationHovered }) {
        this.setState({
            hoveredStation: stationID
        });

        if (stationHovered) {
            let hoveredStation = this.props.stations.find(x => x.id === stationID);

            getMap().panToLocation({
                lat: hoveredStation.latitude,
                lng: hoveredStation.longitude
            });
        }
    }
    onStationHoverEnd() {
        this.setState({
            hoveredStation: ''
        });
    }
    onMapLocationChanged(value) {
        this.setState({
            isMapLocationChanged: value,
        });
    }

    onStationSelect(stationID) {
        var selectedStation = this.props.stations.find(x => x.id === stationID);

        StationsActions.showListAction();
        if (this.props.onStationSelect) {
            this.props.onStationSelect(selectedStation);
        }
    }
    onWindowResize() {
        if (window.innerWidth > 767) {
            if (this.state.listMapView !== FittingStationFinderConstants.MAPLIST_VIEW) {
                this.setState({ listMapView: FittingStationFinderConstants.MAPLIST_VIEW, isListActive: false });
            }
        } else if (this.state.listMapView === FittingStationFinderConstants.MAPLIST_VIEW) {
            this.setState({ listMapView: FittingStationFinderConstants.LIST_VIEW, isListActive: true });
        }
    }
    onMapViewClick() {
        setTimeout(() => {
            getMap().setZoom(11);
        }, 100);
        this.setState({ listMapView: FittingStationFinderConstants.MAP_VIEW, isListActive: false });
    }
    onListViewClick() {
        this.setState({ listMapView: FittingStationFinderConstants.LIST_VIEW, isListActive: true });
    }
}

FinderComponent.propTypes = {
    showSelectStationButton: PropTypes.bool.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    onShowMoreWheelAlignmentInfoClick: PropTypes.func.isRequired,
    wheelAlignment: PropTypes.object.isRequired,
    showQuantityInput: PropTypes.bool.isRequired,
    buy4Pay3: PropTypes.bool,
};

FinderComponent.defaultProps = {
    buy4Pay3: false,
};

export default FinderComponent;
